import _ from 'lodash';
import messages from '../../assets/locale/messages_en.json';

const t = (key: string, params?: any): string => {
  return _.template(messages[key])(params) || key;
};

const isExist = (key) => key in messages;

export default {
  t,
  isExist,
};
